import { FC, PropsWithChildren } from 'react';

import { DataFetchProvider } from '@betterment/js-runtime';
import { useFeatureFlag } from '@betterment/shared-components';
import { ColorModeProvider } from '@betterment/shared-components/src/components/color-mode/ColorModeProvider';
import { StyleClosetThemeProvider, ThemeName } from '@betterment/style-closet-react';

import { GraphQLProvider } from '../graphql';

export const RetailAppProvider: FC<PropsWithChildren> = ({ children }) => {
  const theme = () => {
    return (document.querySelector<HTMLMetaElement>('meta[name="theme"]')?.content || 'default') as ThemeName;
  };

  const { enabled: isColorModeEnabled } = useFeatureFlag({
    splitName: 'retail.color_mode_q1_2025_enabled',
    context: 'RetailAppProvider',
  });

  return (
    <GraphQLProvider>
      <StyleClosetThemeProvider theme={theme()}>
        <DataFetchProvider>
          <ColorModeProvider isEnabled={isColorModeEnabled}>{children}</ColorModeProvider>
        </DataFetchProvider>
      </StyleClosetThemeProvider>
    </GraphQLProvider>
  );
};
